<div class="card bg-blue-200 px-4 pt-4 pb-2">
	<div class="grid">
		<div class="col-2">
			<div class="font-semibold">{{ 'STATUS' | translate }}</div>
		</div>
		<div class="col-7">
			<ng-container *ngIf="!isZL43()">
			<div *ngIf="hasPercentageProgress()" id="deviceAutomationActionProgress" class="flex flex-row align-items-center text-primary">
				<div class="w-4rem mr-2">{{deviceStatus.Percentage}} %</div>
				<p-progressBar [value]="deviceStatus.Percentage" class="w-full" [style]="{'height': '6px'}">
					<!-- USE FOR NOT HAVE PERCENTAGE INSIDE BAR -->
					<ng-template pTemplate="content" let-value>
						<span></span>
					</ng-template>
				</p-progressBar>
			</div>
			<div *ngIf="!hasPercentageProgress()" id="deviceEmptyAutomationActionProgress" class="flex flex-row align-items-center text-primary">
				<div class="w-4rem mr-2">0 %</div>
				<p-progressBar [value]="0" class="w-full" [style]="{'height': '6px'}">
					<ng-template pTemplate="content" let-value>
						<span></span>
					</ng-template>
				</p-progressBar>
			</div>
			</ng-container>
		</div>
		<div class="col-3">
			<div *ngIf="commandDescription" class="font-semibold flex justify-content-end">{{ commandDescription }}</div>
		</div>
	</div>
</div>
